import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** PWA Links 侧边栏图标 */
export function PwaLinksIcon(props) {
    const { size = 20, color = 'currentColor' } = props;
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("rect", { x: "3", y: "3", width: "7", height: "7", rx: "1" }), _jsx("rect", { x: "14", y: "3", width: "7", height: "7", rx: "1" }), _jsx("rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }), _jsx("rect", { x: "14", y: "14", width: "7", height: "7", rx: "1" })] }));
}
/** 应用图标占位 */
export function AppIconPlaceholder(props) {
    const { size = 48, name = '' } = props;
    const initial = name.charAt(0).toUpperCase() || '?';
    return (_jsx("div", { style: {
            width: size,
            height: size,
            borderRadius: 12,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 700,
            fontSize: size * 0.4,
            flexShrink: 0,
        }, children: initial }));
}
/** 外部链接图标 */
export function ExternalLinkIcon(props) {
    const { size = 14, color = 'currentColor' } = props;
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }), _jsx("polyline", { points: "15 3 21 3 21 9" }), _jsx("line", { x1: "10", y1: "14", x2: "21", y2: "3" })] }));
}
//# sourceMappingURL=icons.js.map